export default {
  entityMap: {
    '0': {
      type: 'IMAGE',
      mutability: 'IMMUTABLE',
      data: {
        src: {
          width: 1000,
          height: 637,
          file_name: 'first_image.jpg',
          original_file_name: 'blob',
        },
        isLoading: false,
        size: 'fullWidth',
      },
    },
  },
  blocks: [],
};
